export const Routes = {
  Dashboard: '/dashboard',
  Conversation: {
    pathWithoutParam: '/assist',
    path: '/assist/:conversationId?',
    name: 'assist',
  },
  Authoring: {
    pathWithoutParam: '/authoring',
    path: '/authoring/:conversationId?',
    name: 'authoring',
  },
  Callback: '/callback',
  Home: '/',
  Login: '/login',
  Error: '/error',
  MyCreations: '/my-creations',
  UserImages: '/user-images',
};
